export enum CreditPackTypeEnum {
  zeroKm = 1,
  usedVehicles,
  transferDetran,
}
